import { render } from "./PageNotFoundView.vue?vue&type=template&id=1daf24a1&scoped=true&ts=true"
import script from "./PageNotFoundView.vue?vue&type=script&lang=ts"
export * from "./PageNotFoundView.vue?vue&type=script&lang=ts"

import "./PageNotFoundView.vue?vue&type=style&index=0&id=1daf24a1&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1daf24a1"]])

export default __exports__